import { Box, Modal, Typography } from "@mui/material";
import { IModalFailureCodesSettings } from "./AddFailureCodesModalInterfaces";
import { useStyles, modalStyles } from "./AddFailureCodesModal.styles";

export const AddFailureCodesModal = ({ open, handleClose, title, children }: IModalFailureCodesSettings) => {
    const classes = useStyles();
    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={modalStyles}>
                <Typography className={classes.modalTitle}>{title}</Typography>
                <Box className={classes.bodyContainer}>{children}</Box>
            </Box>
        </Modal>
    );
};
